import React from 'react';
import FinalForm from '@framework/ui/Organisms/FinalForm';
import {
  PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY,
  PORTFOLIO_OPTIONAL_DATA_FORM,
} from './constants';
import OptionalDataFields from './OptionalDataFields';
import useGetPositions from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/useGetPositions';
import { useFormPayloadContext } from '@/creditflowresearch/application/PortfolioMonitor/FormPayloadContext';
import { usePortfoliosContext } from '@/creditflowresearch/application/PortfolioMonitor/PortfoliosContext';
import { usePortfolioMonitorContext } from '@/creditflowresearch/application/PortfolioMonitor/PortfolioMonitorContext';
import { validate } from './validators';

import formStyles from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/PortfolioForm/formStyles.module.scss';

const OptionalDataTable = (props) => {
  const { positions, listIndex } = useGetPositions();
  const { payload, setPayload } = useFormPayloadContext();
  const { createPortfolio, getPortfolioCollection, hasPortfolio } = usePortfoliosContext();
  const { setIsFormOpened } = usePortfolioMonitorContext();

  const submit = async (values) => {
    setPayload((prevState) => {
      prevState.lists[listIndex].positions = values[PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY];
      return prevState;
    });

    await createPortfolio(payload, hasPortfolio);
    await getPortfolioCollection();
    setPayload({});
    setIsFormOpened((prev) => !prev);
  };

  return (
    <FinalForm
      className={ formStyles.virtualListContainer }
      dataTest={ PORTFOLIO_OPTIONAL_DATA_FORM }
      render={ () => <OptionalDataFields { ...props } /> }
      onSubmit={ submit }
      initialValues={ { [PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY]: positions } }
      validate={ validate }
    />
  );
};

export default OptionalDataTable;
